import * as React from "react";
import { useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import { Stack } from "office-ui-fabric-react";
import { mergeStyles } from "office-ui-fabric-react";
import { useTranslation } from 'react-i18next';

import { toggleVehiclePanel } from "../../../config/redux/vehicles/vehiclesActions";
import { useVehicleForm } from "../hooks/useVehicleFrom";
import VehicleOrderTypesCheckboxes from "./VehicleOrderTypesCheckboxes";
import NewFormBtns from "../../common/layout/form/NewFormBtns";
import NewFormField from "../../common/layout/form/NewFormField";
import { vehicleValidation } from "../actions/validationSchems";
import FormDropDown from "../../common/layout/form/FormDropDown";
import { useDrivers } from "../hooks/useDrivers";
import ActivityIndicator from "../../common/layout/ActivityIndicator";
import MessageContainer from "../../auth/components/register/forms/MessageContainer";
import { clearAlerts } from "../../../config/redux/alerts/alertsActions";

const margin = mergeStyles({
  marginTop: 20,
});

const VehicleFrom: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('admin');
  const { initValues, handleSubmit,selectedVehicles, loading } = useVehicleForm();
  const options = useDrivers()
  const cancelForm = () => {
    dispatch(toggleVehiclePanel({ open: false }));
    dispatch(clearAlerts())
  };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={handleSubmit}
      validationSchema={vehicleValidation}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ handleSubmit, values, setFieldValue }) => (
        <Form translate="yes" onSubmit={handleSubmit}>
          <Stack>
            <NewFormField name="brand" label={t('vehicles.form.brand') as string} />
            <NewFormField name="model" label={t('vehicles.form.model') as string} />
            <NewFormField name="registerNumber" label={t('vehicles.form.registerNumber') as string} />
            <FormDropDown options={options} name="driver" headerText={t('vehicles.form.driver') as string} placeholder={t('vehicles.form.driverPlaceholder') as string}/>
            <VehicleOrderTypesCheckboxes values={values} />
            <div className={margin}>
              <NewFormBtns
                cancelForm={cancelForm}
                submitBtnText={selectedVehicles[0] ? t('vehicles.form.save') as string : t('vehicles.form.add') as string}
                disabled={loading}
                positionAbsolute={true}
              />
            </div>
            <div className={margin}>
            {loading ? <ActivityIndicator/> : <MessageContainer/>}
            </div>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default VehicleFrom;
